import { useLocaleStore, type Locale } from "@/stores/localeStore"

export type LocalizedCopy<T> = Record<Locale, T>

export function pickLocalizedCopy<T>(copy: LocalizedCopy<T>, locale?: Locale): T {
	const resolvedLocale = locale ?? useLocaleStore.getState().locale
	return copy[resolvedLocale] ?? copy.ca
}

export function useLocalizedCopy<T>(copy: LocalizedCopy<T>): T {
	const locale = useLocaleStore((state) => state.locale)
	return pickLocalizedCopy(copy, locale)
}
